<template>
  <transition
    name="fade"
    mode="out-in"
  >
    <div
      v-if="showAlert"
      class="discount-alert card"
    >
      <header class="discount-alert__header">
        <h3 class="discount-alert__title">
          <dr-icon
            class="discount-alert__icon"
            color="green"
            name="exclamation"
          />

          Atenção
        </h3>

        <i
          class="icon icon-cross discount-alert__close"
          @click="showAlert = false"
        />
      </header>

      <article class="discount-alert__body">
        <p class="discount-alert__text">
          O Dr. Conecta tem uma promoção exclusiva: faça sua integração
          com o aplicativo e Marketplace Dr. Conecta, disponibilizando
          ao menos <strong>5 horários</strong> da sua agenda para novos
          pacientes, e garanta <strong>50% de desconto</strong> no plano
          PREMIUM.
        </p>

        <button
          v-if="$route.name !== 'DoctorAppIntegrationPrices'"
          class="btn btn-green !text-sm !flex !items-center !justify-center !h-8 !p-3 !px-8 !mt-4 !mx-auto"
          @click="$router.push({ name: 'DoctorAppIntegrationPrices' })"
        >
          Quero ganhar 50% de desconto
        </button>
      </article>
    </div>
  </transition>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'AlertDiscount',

  data () {
    return {
      showAlert: false
    }
  },

  computed: {
    ...mapGetters({ plan: 'getPlan' })
  },

  created () {
    this.checkHealthplaceRequirements()
      .then((status) => {
        if (!status && this.plan.isPro) {
          this.showAlert = true
        }
      })
  },

  methods: {
    checkHealthplaceRequirements () {
      const url = '/doctor/doctor_health_place/has_agenda_available'

      return new Promise((resolve) => {
        this.$http
          .get(url, this.$store.getters.getAuthHeader)
          .then((res) => {
            resolve(Boolean(res.data))
          })
          .catch(() => resolve(false))
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '$vars';

.discount-alert {
  @apply mb-4 p-3 block;
  background-color: lighten($color-green, 41%);
  border-color: $color-green;

  &__header {
    @apply flex flex-row items-center justify-between;
  }

  &__title {
    @apply uppercase flex flex-row items-center justify-start;
    color: darken($color-green, 20%);
    font-family: $font1;
    font-size: 0.75rem;
    font-weight: 550;
  }

  &__close {
    align-self: flex-start;
    margin-left: auto;
  }

  &__icon {
    @apply mr-1;
    height: 1rem;
    width: 1rem;
  }

  &__text {
    @apply m-0 px-4 pr-8;
    font-size: 0.8rem;
  }

  &__close {
    @apply cursor-pointer;
    color: darken($color-green, 20%);
  }
}
</style>
